/** @format */

import {SensorGroupColorType} from 'types';

import {SensorsList} from '../../helpers/sensors/types';

export interface SensorStats {
  allCount: number;
  new: number;
  newCount: number;
  fixed: number;
  fixedCount: number;
}

export type StatsSensorsResult = {
  [key in SensorGroupColorType]: SensorStats;
};

const statsSensors = (sensors?: SensorsList): StatsSensorsResult => {
  const defaultStats: SensorStats = {
    allCount: 0,
    new: 0,
    newCount: 0,
    fixed: 0,
    fixedCount: 0,
  };

  const result: StatsSensorsResult = {
    RED: {...defaultStats},
    YELLOW: {...defaultStats},
    GRAY: {...defaultStats},
  };

  if (!sensors) {
    return result;
  }

  const statYellow = new Set<string>();
  const statRed = new Set<string>();
  const statGray = new Set<string>();

  const dateArray = Object.keys(sensors);

  dateArray.forEach(date => {
    const colorKeys = Object.keys(sensors[date]) as SensorGroupColorType[];
    colorKeys.forEach(color => {
      const sensorGroup = sensors[date][color];
      if (sensorGroup) {
        result[color].fixedCount += sensorGroup.fixedCount;
        result[color].fixed += sensorGroup.fixed;
        result[color].new += sensorGroup.new;
        result[color].newCount += sensorGroup.newCount;

        sensorGroup.detailed.forEach(check => {
          if (color === 'YELLOW') {
            statYellow.add(check.id);
          } else if (color === 'RED') {
            statRed.add(check.id);
          } else if (color === 'GRAY') {
            statGray.add(check.id);
          }
        });
      }
    });
  });

  result.RED.allCount = Array.from(statRed).length;
  result.YELLOW.allCount = Array.from(statYellow).length;
  result.GRAY.allCount = Array.from(statGray).length;

  return result;
};

export {statsSensors};
